import React, { Component } from 'react';
//import MaterialTable from 'material-table';
//import AutorenewIcon from '@material-ui/icons/Autorenew';

import Grid from "@material-ui/core/Grid";
//import { ProjectData } from "../components/ProjectData";
//import { ProjectKeyInformation } from "../components/ProjectKeyInformation";
//import { EntityInCharge } from "../components/EntityInCharge";
//import { ProjectFinancialData } from "../components/ProjectFinancialData";
//import { ProjectDates } from "../components/ProjectDates";
//import { RomReview } from "../components/RomReview";
import Button from "@material-ui/core/Button";
//import { inject, observer } from "mobx-react";
//import { stores } from "../store";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

//import { ProjectSelect } from "../components/ProjectSelect";
//import { RomData } from "../components/RomData";

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import TextField from '@material-ui/core/TextField';

//import clsx from 'clsx';
//import { makeStyles, useTheme } from '@material-ui/core/styles';
//import Input from '@material-ui/core/Input';
//import InputLabel from '@material-ui/core/InputLabel';
//import MenuItem from '@material-ui/core/MenuItem';
//import FormControl from '@material-ui/core/FormControl';
//import ListItemText from '@material-ui/core/ListItemText';
//import Select from '@material-ui/core/Select';
//import Checkbox from '@material-ui/core/Checkbox';
//import Chip from '@material-ui/core/Chip';

//import InputAdornment from "@material-ui/core/InputAdornment";
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";

import MUIDataTable from "mui-datatables";
import Autocomplete from '@material-ui/lab/Autocomplete';
import { array } from 'prop-types';

import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import Typography from '@material-ui/core/Typography';

import 'moment-timezone';
import moment from 'moment'

import {
    //typeOfIPAOptions,
    //typeOfFAYearOptions,
    //typeOfFAMAOptions,
    sectorOptions,
    //typeOfAnnualOptions,
    //typeOfProjectOptions
} from '../components/Enums';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
//const MenuProps = {
//    PaperProps: {
//        style: {
//            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
//            width: 250,
//        },
//    },
//};

export class ThematicReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rowsSelectedQuestionNumber: [],
            rowsSelectedMission: [],
            missionList: [],
            typeOfROM: 1,
            isFetching: false,
            questions: [],
            selectedQuestions: [],
            selectedMissions: [],
            questionsOngoingMQ: [
                { TypeId: "OmqQ02Does", TypeName: "Ongoing MQ 1.1 - Does the project constitute an adequate response to the current needs and rights of the target groups / end beneficiaries?" },
                { TypeId: "OmqQ04Is", TypeName: "Ongoing MQ 1.2 - Is the project adapted to the present institutional, human and financial capacities of the partner government and/ or other key stakeholder(s) with a role in the implementation?" },
                { TypeId: "OmqQ06Do", TypeName: "Ongoing MQ 1.3 - Do all the key stakeholders demonstrate effective commitment to the objectives of the project (i.e. ownership)?" },
                { TypeId: "OmqQ08Is", TypeName: "Ongoing MQ 1.4 - Is there an effective government led system of sector coordination (including Capacity Development) involving the relevant local stakeholders and donors?" },
                { TypeId: "OmqQ10Are", TypeName: "Ongoing MQ 1.5 - Is the project likely to benefit or is benefiting from any complementarity/synergies with other projects funded by the EU and other entities(donors, public and private)?" },
                { TypeId: "OmqQ12Have", TypeName: "Ongoing MQ 1.6 - What is the current quality of the intervention logic? Are planned outputs and outcomes coherent and feasible, and have key assumptions and risks been clearly identified?" },
                { TypeId: "OmqQ14Are", TypeName: "Ongoing MQ 1.7a - Are the indicators well defined and relevant to measure the achievement of the objectives?" },
                { TypeId: "OmqQ16Are", TypeName: "Ongoing MQ 1.7b - Is the horizontal logic of the Logical Framework Matrix (LFM) adequate, i.e. choice of indicators, data availability, baseline data, target values?" },
                { TypeId: "OmqQ18Are", TypeName: "Ongoing MQ 1.7c - Are the indicators sex-disaggregated, (if relevant)?" },
                { TypeId: "OmqQ20Were", TypeName: "Ongoing MQ 1.7d - Were baselines set for each indicator? Were they updated during the project implementation?" },
                { TypeId: "OmqQ22Are", TypeName: "Ongoing MQ 1.7e - Are targets values set at the start of the project? If so, are they realistic or was there a need to revise/update them?" },
                { TypeId: "OmqQ24Have", TypeName: "Ongoing MQ 2.1 - Are the chosen implementation mechanisms (including choice of implementation modalities, entities and contractual arrangements) proving to be appropriate to achieve the planned outputs and contribute to the achievement of the outcomes?" },
                { TypeId: "OmqQ26Do", TypeName: "Ongoing MQ 2.2 - Do the partner government and other partners effectively steer the project?" },
                { TypeId: "OmqQ28Do", TypeName: "Ongoing MQ 2.3a - Are the inputs / resources provided by the various stakeholders (still) adequate for achieving the planned results?" },
                { TypeId: "OmqQ30To", TypeName: "Ongoing MQ 2.3b - Are resources other than EU funds made available for the project?" },
                { TypeId: "OmqQ32To", TypeName: "Ongoing MQ 2.3c - To what degree are resources (inputs) from other stakeholders available on time?" },
                { TypeId: "OmqQ34If", TypeName: "Ongoing MQ 2.4a - Has the project encountered any delays? If yes, how important are they and what are the consequences on the project?" },
                { TypeId: "OmqQ36What", TypeName: "Ongoing MQ 2.4b - What are the reasons for the delays and to what extent have corrective measures been implemented?" },
                { TypeId: "OmqQ38To", TypeName: "Ongoing MQ 2.4c - Was the planning revised accordingly?" },
                { TypeId: "OmqQ40Are", TypeName: "Ongoing MQ 2.5 - Are the outputs being produced/ delivered in a cost-efficient manner?" },
                { TypeId: "OmqQ42Is", TypeName: "Ongoing MQ 2.6 - Does the project have an adequate internal monitoring system?" },
                { TypeId: "OmqQ44Is", TypeName: "Ongoing MQ 3.1 - Is the progress of each output conforming to plan?" },
                { TypeId: "OmqQ46Is", TypeName: "Ongoing MQ 3.2 - Are the outputs (including those related to Capacity Development support) being achieved with the expected quality?" },
                { TypeId: "OmqQ48Are", TypeName: "Ongoing MQ 3.3 - Are the expected outcomes likely to be achieved (including Capacity Development)?" },
                { TypeId: "OmqQ50Does", TypeName: "Ongoing MQ 3.4 - Does the P/P effectively influence the partner�s relevant policy and actions?" },
                { TypeId: "OmqQ52Are", TypeName: "Ongoing MQ 4.1 - Are key stakeholders attaining the necessary capacities (including institutional, human and financial) to ensure the continued flow of benefits/ services ?" },
                { TypeId: "OmqQ54Has", TypeName: "Ongoing MQ 4.2 - Have the key stakeholders provided adequate coordination, interaction and support to the project?" },
                { TypeId: "OmqQ56Is", TypeName: "Ongoing MQ 4.3 - Is access to the benefits generated by the project affordable for target groups over the long term?" },
                { TypeId: "OmqQ58Have", TypeName: "Ongoing MQ 4.4 - Have the relevant authorities taken the financial measure(s) to ensure the continuation of services after the end of the project?" },
                { TypeId: "OmqQ62Has", TypeName: "Ongoing MQ 4.5 - Has the private sector been sufficiently involved with a view to contributing to the sustainability of the project?" },
                { TypeId: "OmqQ64Have", TypeName: "Ongoing MQ 4.6 - Have the necessary measures been taken to address environmental sustainability?" },
                { TypeId: "OmqQ66Have", TypeName: "Ongoing MQ 4.7 - Have the necessary measures been taken into account to enhance the role of women?" },
                { TypeId: "OmqQ68Have", TypeName: "Ongoing MQ 5.1 - To what extent have recommendations raised in previous ROM reviews or project evaluations been taken into account?" },
                { TypeId: "OmqQ70Have", TypeName: "Ongoing MQ 5.2 - Is the application of the EU requirement and published guidelines on communication and visibility benefitting the EU image in the country/ region ?" },
                { TypeId: "OmqQ72Are", TypeName: "Ongoing MQ 5.3 - Are there any good practices inherent to the P/P which could be useful to share beyond the P/P context?" },

                //{ TypeId: "OmrQ1Context", TypeName: "Ongoing MR - Context" },
                //{ TypeId: "OmrQ2Description", TypeName: "Ongoing MR - Description of the Intervention Logic" },
                //{ TypeId: "OmrQ3Relevance", TypeName: "Ongoing MR - Relevance" },
                //{ TypeId: "OmrQ4Efficiency", TypeName: "Ongoing MR - Efficiency" },
                //{ TypeId: "OmrQ5Effectiveness", TypeName: "Ongoing MR - Effectiveness" },
                //{ TypeId: "OmrQ6Sustainability", TypeName: "Ongoing MR - Sustainability" },
                //{ TypeId: "OmrConclusions", TypeName: "Ongoing MR - Conclusions" },
                //{ TypeId: "OmrRecommendations", TypeName: "Ongoing MR - Recommendations" },
            ],
            questionsExpostMQ: [
                { TypeId: "EmqQ2Didthe", TypeName: "Ex-post MQ 1.1 - Did the project constitute an adequate response to the prevailing needs and rights of the target groups / end beneficiaries?" },
                { TypeId: "EmqQ4Hasthe", TypeName: "Ex-post MQ 1.2 - Was the project adapted to the then institutional, human and financial capacities of the partner government and/ or other key stakeholder(s) with a role in the implementation?" },
                { TypeId: "EmqQ6Havethe", TypeName: "Ex-post MQ 1.3 - Did all the key stakeholders demonstrate effective commitment (i.e. ownership) to the objectives of the project?" },
                { TypeId: "EmqQ8Hasthere", TypeName: "Ex-post MQ 1.4 - Was there an effective government-led system of sector coordination (including Capacity Development) involving the relevant local stakeholders and donors?" },
                { TypeId: "EmqQ10Havethere", TypeName: "Ex-post MQ 1.5 - Did the project benefit from any complementarity/synergies with other projects funded by the EU or other donors(public or private)?" },
                { TypeId: "EmqQ12Hasan", TypeName: "Ex-post MQ 1.6 - What was the quality of the intervention logic? Were planned outputs and outcomes coherent and feasible, and were key assumptions and risks clearly identified?" },
                { TypeId: "EmqQ14Werethe", TypeName: "Ex-post MQ 1.7a - Were the indicators well defined and relevant to measure the achievement of the objectives?" },
                { TypeId: "EmqQ16Hasall", TypeName: "Ex-post MQ 1.7b - Was the horizontal logic of the Logical Framework Matrix (LFM) adequate, i.e. choice of indicators, data availability, baseline data, target values?" },
                { TypeId: "EmqQ18Havethe", TypeName: "Ex-post MQ 1.7c - Were the indicators sex-disaggregated (if relevant)?" },
                { TypeId: "EmqQ20Were", TypeName: "Ex-post MQ 1.7d - Were baselines set for each indicator? Were they updated during the project implementation?" },
                { TypeId: "EmqQ22Were", TypeName: "Ex-post MQ 1.7e - Were target values set at the start of the project? If so, were they realistic or was there a need to revise/ update them in the course of the project ?" },
                { TypeId: "EmqQ24Have", TypeName: "Ex-post MQ 2.1 - Were the chosen implementation mechanisms (including choice of implementation modalities, entities and contractual arrangements) proving to be appropriate to achieve the planned outputs and contribute to the achievement of the outcomes?" },
                { TypeId: "EmqQ26Have", TypeName: "Ex-post MQ 2.2 - Did the partner government and other partners effectively steer the project?" },
                { TypeId: "EmqQ28Inputs", TypeName: "Ex-post MQ 2.3a - Were the inputs / resources provided by the various stakeholders adequate for achieving the planned results?" },
                { TypeId: "EmqQ30What", TypeName: "Ex-post MQ 2.3b - Were resources other than EU funds made available for the project?" },
                { TypeId: "EmqQ32Towhat", TypeName: "Ex-post MQ 2.3c - To what degree were resources (inputs) from other stakeholders available on time?" },
                { TypeId: "EmqQ34Delays", TypeName: "Ex-post MQ 2.4 - Did the project encounter any delays? If yes, how important were they and what were the consequences on the project?" },
                { TypeId: "EmqQ36Were", TypeName: "Ex-post MQ 2.5 - Were the outputs produced/ delivered in a cost-efficient manner?" },
                { TypeId: "EmqQ38Wasthe", TypeName: "Ex-post MQ 2.6 - Was the project adequately monitored by the implementing partner, the partner government and other key stakeholders?" },
                { TypeId: "EmqQ40Hasthe", TypeName: "Ex-post MQ 3.1 - Was the progress of each output conforming to plan?" },
                { TypeId: "EmqQ42Hasthe", TypeName: "Ex-post MQ 3.2 - Were the outputs (including those related to Capacity Development) being achieved with the expected quality?" },
                { TypeId: "EmqQ44Towhat", TypeName: "Ex-post MQ 3.3 - Were the expected outcomes achieved (including Capacity Development)?" },
                { TypeId: "EmqQ46Didthe", TypeName: "Ex-post MQ 3.4 - Did the P/P effectively influence the partner government�s related policies and actions?" },
                { TypeId: "EmqQ48Hasthere", TypeName: "Ex-post MQ 4.1 - Has there been an apparent impact of the action?" },
                { TypeId: "EmqQ50Towhat", TypeName: "Ex-post MQ 4.2 - To what extent did the project have an indirect positive and/or negative impact?" },
                { TypeId: "EmqQ52Towhat", TypeName: "Ex-post MQ 4.3 - To what extent have there been external factors that positively or negatively affected the impact of the project? Have measures been implemented to minimize these factors?" },
                { TypeId: "EmqQ54Hasthe", TypeName: "Ex-post MQ 5.1 - Have key stakeholders attained the necessary capacities (including institutional, human and financial) to ensure the continued flow of benefits/ services ?" },
                { TypeId: "EmqQ56Hasthe", TypeName: "Ex-post MQ 5.2 - Have the key stakeholders provided adequate coordination, interaction and support to the project?" },
                { TypeId: "EmqQ58Haveaccess", TypeName: "Ex-post MQ 5.3 - Is access to the benefits generated by the project affordable for target groups over the long term?" },
                { TypeId: "EmqQ60Havethe", TypeName: "Ex-post MQ 5.4 - Has the Beneficiary taken the financial measure(s) to ensure the continuation of services after the end of the project?" },
                { TypeId: "EmqQ62Towhat", TypeName: "Ex-post MQ 5.5 - Has the private sector been sufficiently involved with a view to contributing to the sustainability of the project?" },
                { TypeId: "EmqQ64Havethe", TypeName: "Ex-post MQ 5.6 - Have the necessary measures been taken to address environmental sustainability?" },
                { TypeId: "EmqQ66Havethe", TypeName: "Ex-post MQ 5.7 - Have the necessary measures been taken into account to enhance the role of women?" },
                { TypeId: "EmqQ68Hasthe", TypeName: "Ex-post MQ 6.1 - Was the project ROM monitored previously?" },
                { TypeId: "EmqQ69Havethe", TypeName: "Ex-post MQ 6.2 - Have the communication and visibility actions been implemented in an appropriate manner?" },
                { TypeId: "EmqQ70Werethere", TypeName: "Ex-post MQ 6.3 - Are there good practices inherent to the project which could be useful to share beyond the project context?" },

                //{ TypeId: "EmrQ1Context", TypeName: "Ex-post MR - Context" },
                //{ TypeId: "EmrQ2Description", TypeName: "Ex-post MR - Description of the Intervention Logic" },
                //{ TypeId: "EmrQ3Relevance", TypeName: "Ex-post MR - Relevance" },
                //{ TypeId: "EmrQ4Efficiency", TypeName: "Ex-post MR - Efficiency" },
                //{ TypeId: "EmrQ5Effectiveness", TypeName: "Ex-post MR - Effectiveness" },
                //{ TypeId: "EmrQ6Impact", TypeName: "Ex-post MR - Impact" },
                //{ TypeId: "EmrQ7Sustainability", TypeName: "Ex-post MR - Sustainability" },
                //{ TypeId: "EmrConclusions", TypeName: "Ex-post MR - Conclusions" },
                //{ TypeId: "EmrLessonsLearnt", TypeName: "Ex-post MR - Lessons Learnt" },
            ],
            questionsSupplyOngoing: [
                { TypeId: "OmsQ1Are", TypeName: "Supply Ongoing NS 1.1 - Are the supplies identified in the supply contact meeting the needs of the target groups / end beneficiaries?" },
                { TypeId: "OmsQ2Is", TypeName: "Supply Ongoing NS 1.2 - Is the beneficiary involved in the definition of the supplies?" },
                { TypeId: "OmsQ3Define", TypeName: "Supply Ongoing NS 1.3 - Define the type of supplies to be provided." },
                { TypeId: "OmsQ17Have", TypeName: "Supply Ongoing NS 1.4a - Have indicators been defined to measure the delivery of the supplies?" },
                { TypeId: "OmsQ4Are", TypeName: "Supply Ongoing NS 1.4b - Are all related data available on the tendering, evaluation and provision of supplies?" },
                { TypeId: "OmsQ5Does", TypeName: "Supply Ongoing NS 2.1 - Do the supplies funded correspond to the needs of the action?" },
                { TypeId: "OmsQ7Has", TypeName: "Supply Ongoing NS 2.2 - Has there been delays and how important are they and what are the consequences on the project?" },
                { TypeId: "OmsQ8What", TypeName: "Supply Ongoing NS 2.3 - What are the reasons for the delays and to what extent have appropriate corrective measures been implemented?" },
                { TypeId: "OmsQ9How", TypeName: "Supply Ongoing NS 3.1 - How satisfactory is the quality of the supplies in relation to target groups?" },
                { TypeId: "OmsQ10Are", TypeName: "Supply Ongoing NS 4.1 - Are key stakeholders acquiring the necessary skills to benefit from the supplies� component?" },
                { TypeId: "OmsQ11Is", TypeName: "Supply Ongoing NS 4.2 - Is access to the benefits affordable for target groups in the long term?" },
                { TypeId: "OmsQ12Have", TypeName: "Supply Ongoing NS 4.3 - Have the relevant authorities taken the financial measure(s) to ensure continuity of maintaining the supplies component at the end of the intervention?" },
                { TypeId: "OmsQ13Has", TypeName: "Supply Ongoing NS 4.4 - Has the private sector been involved in any stage of the supply component?  If so, please state involvement." },
                { TypeId: "OmsQ14Have", TypeName: "Supply Ongoing NS 4.5 - Have the necessary measures been taken to address the environmental sustainability?" },
                { TypeId: "OmsQ15Have", TypeName: "Supply Ongoing NS 5.1 - Have the communication and visibility actions been implemented in an appropriate manner?" },
                { TypeId: "OmsQ16Is", TypeName: "Supply Ongoing NS 5.2 - Is the supplies component in line with the requirements of the other components of the current project (if applicable)?" },
            ],
            questionsSupplyExpost: [
                { TypeId: "EmsQ1Were", TypeName: "Supply Ex-post NS 1.1 - Were the supplies identified in the Supply Contact in line with the target groups / end beneficiaries needs?" },
                { TypeId: "EmsQ2Was", TypeName: "Supply Ex-post NS 1.2 - Was the beneficiary involved in the definition of the supply of goods?" },
                { TypeId: "EmsQ3Define", TypeName: "Supply Ex-post NS 1.3 - Define the type of supplies provided." },
                { TypeId: "EmsQ4Were", TypeName: "Supply Ex-post NS 1.4a - Were indicators been defined to measure the delivery of the supplies?" },
                { TypeId: "EmsQ5Have", TypeName: "Supply Ex-post NS 1.4b - Have all related data available on the tendering, evaluation and provision of supplies available?" },
                { TypeId: "EmsQ6Did", TypeName: "Supply Ex-post NS 2.1 - Did the supplies funded by the action correspond to the needsof the action?" },
                { TypeId: "EmsQ7Was", TypeName: "Supply Ex-post NS 2.2 - Was there delays encountered and how important were they and what were the consequences on the project?" },
                { TypeId: "EmsQ8What", TypeName: "Supply Ex-post NS 2.3 - What are the reasons for the delays and to what extent have appropriate corrective measures been implemented?" },
                { TypeId: "EmsQ9How", TypeName: "Supply Ex-post NS 3.1 - How satisfactory is the quality of the supplies for the recipients?" },
                { TypeId: "EmsQ10Identify", TypeName: "Supply Ex-post NS 4.1 - Identify the impact of the delivery of the provided supplies for both the medium and long term?" },
                { TypeId: "EmsQ11What", TypeName: "Supply Ex-post NS 4.2 - What is the impact of the supplies on the project stakeholders? had an indirect positive and / or a negative impact?" },
                { TypeId: "EmsQ12Has", TypeName: "Supply Ex-post NS 4.3 - Has there been any indirect positive and/or a negative impact?" },
                { TypeId: "EmsQ13Did", TypeName: "Supply Ex-post NS 5.1 - Did key stakeholders acquire the necessary skills to benefit from the delivery of supplies?" },
                { TypeId: "EmsQ14Are", TypeName: "Supply Ex-post NS 5.2 - Are the benefits of the supplies for target groups affordable in the long term ?" },
                { TypeId: "EmsQ15Has", TypeName: "Supply Ex-post NS 5.3 - Has the relevant authorities taken the financial measure(s) to ensure maintenance of the supplies(if relevant) after the delivery of supplies?" },
                { TypeId: "EmsQ16Has", TypeName: "Supply Ex-post NS 5.4 - Has the private sector been involved in maintaining supplies?" },
                { TypeId: "EmsQ17Have", TypeName: "Supply Ex-post NS 5.5 - Have the necessary measures been taken to address the environmental sustainability ?" },
                { TypeId: "EmsQ19Have", TypeName: "Supply Ex-post NS 6.1 - Have the communication and visibility actions been implemented in an appropriate manner ?" },
                { TypeId: "EmsQ20Was", TypeName: "Supply Ex-post NS 6.2 - Was the supply in line with the requirements of the other components of the current project(if applicable)?" },
            ],
            questionsWorksOngoing: [
                { TypeId: "OmwQ1Are", TypeName: "Works Ongoing NW 1.1 - Are the works contract clearly identified meeting the needs of the target groups?" },
                { TypeId: "OmwQ2Is", TypeName: "Works Ongoing NW 1.2 - Is the beneficiary involved in the definition of the works component?" },
                { TypeId: "OmwQ3Define", TypeName: "Works Ongoing NW 1.3 - Define the type of works provided." },
                { TypeId: "OmwQ4Are", TypeName: "Works Ongoing NW 1.4a - Have indicators been defined to measure the delivery of the works component?" },
                { TypeId: "OmwQ4Are2", TypeName: "Works Ongoing NW 1.4b - Are all related data available on the tendering, evaluation and provision of works component?" },
                { TypeId: "OmwQ5Does", TypeName: "Works Ongoing NW 2.1 - Does the works component funded by the action correspond to the needs of the action?" },
                { TypeId: "OmwQ6Has", TypeName: "Works Ongoing NW 2.2 - Has there been delays and how important are they and what are the consequences on the project?" },
                { TypeId: "OmwQ7What", TypeName: "Works Ongoing NW 2.3 - What are the reasons for the delays and to what extent have appropriate corrective measures been implemented?" },
                { TypeId: "OmwQ8How", TypeName: "Works Ongoing NW 3.1 - How satisfactory is the quality of the works in relation to target groups ?" },
                { TypeId: "OmwQ9Are", TypeName: "Works Ongoing NW 4.1 - Are key stakeholders acquiring the necessary skills to benefit from the Work�s component ?" },
                { TypeId: "OmwQ10Is", TypeName: "Works Ongoing NW 4.2 - Is access to the benefits affordable for target groups in the long term ?" },
                { TypeId: "OmwQ11Have", TypeName: "Works Ongoing NW 4.3 - Have the relevant authorities taken the financial measure(s) to ensure continuity of maintaining the works component at the end of the intervention ?" },
                { TypeId: "OmwQ12Has", TypeName: "Works Ongoing NW 4.4 - Has the private sector been involved in any stage of the works component? If so, please state involvement" },
                { TypeId: "OmwQ13Have", TypeName: "Works Ongoing NW 4.5 - Have the necessary measures been taken to address the environmental sustainability ?" },
                { TypeId: "OmwQ14Have", TypeName: "Works Ongoing NW 5.1 - Have the communication and visibility actions been implemented in an appropriate manner ?" },
                { TypeId: "OmwQ15Is", TypeName: "Works Ongoing NW 5.2 - Is the works� component in line with the requirements of the other components of the current project(if applicable)?" },
            ],
            questionsWorksExpost: [
                { TypeId: "EmwQ1Were", TypeName: "Works Ex-post MQ 1.1 - Were the works identified in the works� contract in line with the target groups needs?" },
                { TypeId: "EmwQ2Was", TypeName: "Works Ex-post MQ 1.2 - Was the beneficiary involved in the definition of the works contract?" },
                { TypeId: "EmwQ3Define", TypeName: "Works Ex-post MQ 1.3 - Define the type of works provided." },
                { TypeId: "EmwQ4Were", TypeName: "Works Ex-post MQ 1.4a - Were indicators been defined to measure the delivery of the works contract ?" },
                { TypeId: "EmwQ5Have", TypeName: "Works Ex-post MQ 1.4b - Have all related data available on the tendering, evaluation and provision of the works component available?" },
                { TypeId: "EmwQ6Did", TypeName: "Works Ex-post MQ 2.1 - Did the works component funded by the action correspond to the needs of the action ?" },
                { TypeId: "EmwQ7Was", TypeName: "Works Ex-post MQ 2.2 - Was there delays encountered and how important were they and what were the consequences on the project?" },
                { TypeId: "EmwQ8What", TypeName: "Works Ex-post MQ 2.3 - What are the reasons for the delays and to what extent have appropriate corrective measures been implemented?" },
                { TypeId: "EmwQ9How", TypeName: "Works Ex-post MQ 3.1 - How satisfactory is the quality of the works component for the recipients?" },
                { TypeId: "EmwQ10Identify", TypeName: "Works Ex-post MQ 4.1 - Identify the impact of the delivery of the provided works component for both the medium and the long term ?" },
                { TypeId: "EmwQ11What", TypeName: "Works Ex-post MQ 4.2 - What is the impact of the works contract on the project stakeholders? Has there been an indirect positive and / or a negative impact?" },
                { TypeId: "EmwQ12Has", TypeName: "Works Ex-post MQ 4.3 - Has there been any indirect positive and/or a negative impact due to the implementation of the works contract ?" },
                { TypeId: "EmwQ13Did", TypeName: "Works Ex-post MQ 5.1 - Did key stakeholders acquire the necessary skills to benefit from the delivery of the works contract?" },
                { TypeId: "EmwQ14Are", TypeName: "Works Ex-post MQ 5.2 - Are the benefits of the works contract for target groups affordable in the long term ?" },
                { TypeId: "EmwQ15Has", TypeName: "Works Ex-post MQ 5.3 - Has the relevant authorities taken the financial measure(s) to ensure maintenance of the works(if relevant) after the implementation of the works ?" },
                { TypeId: "EmwQ16Has", TypeName: "Works Ex-post MQ 5.4 - Has the private sector been involved in any aspect of the works contract ?" },
                { TypeId: "EmwQ17Have", TypeName: "Works Ex-post MQ 5.5 - Have the necessary measures been taken into account to address the environmental sustainability?" },
                { TypeId: "EmwQ18Have", TypeName: "Works Ex-post MQ 6.1 - Have the communication and visibility actions been implemented in an appropriate manner ?" },
                { TypeId: "EmwQ19Was", TypeName: "Works Ex-post MQ 6.2 - Was the works contract in line with the requirements of the other components of the current project (if applicable)?" },
            ],
            typeOfROMOptions: [
                { TypeId: 1, TypeName: "On Going" },
                { TypeId: 2, TypeName: "Ex-Post" },
                { TypeId: 3, TypeName: "Supply On Going" },
                { TypeId: 4, TypeName: "Supply Ex-Post" },
                { TypeId: 5, TypeName: "Works On Going" },
                { TypeId: 6, TypeName: "Works Ex-Post" },
            ],
            reportQuestion: "",
            thematicReport: [],
            missionDateSearchStart: new Date("01/01/2000"),
            missionDateSearchEnd: new Date("01/01/2030"),
            sector: "",
            returnFileType: -1,
        };
    }

    componentDidMount = async () => {

        let pageTokenAuthData = {
            operation: "AuthCheckToken"
        };

        await fetch(global.variables.API_CHECKTOKEN, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(pageTokenAuthData)
        })
            .then(response => response.json())
            .then(result => {
                if (result.resultstate > 0 ||
                    result.authresp === 2) {
                    window.location.href = "/login";
                }
            }).catch(() => {
                window.location.href = "/login";
            });

        if (this.state.typeOfROM === 1) {
            this.setState({
                questions: this.state.questionsOngoingMQ
            });
        } else if (this.state.typeOfROM === 2) {
            this.setState({
                questions: this.state.questionsExpostMQ
            });
        } else if (this.state.typeOfROM === 3) {
            this.setState({
                questions: this.state.questionsSupplyOngoing
            });
        } else if (this.state.typeOfROM === 4) {
            this.setState({
                questions: this.state.questionsSupplyExpost
            });
        } else if (this.state.typeOfROM === 5) {
            this.setState({
                questions: this.state.questionsWorksOngoing
            });
        } else if (this.state.typeOfROM === 6) {
            this.setState({
                questions: this.state.questionsWorksExpost
            });
        }

        this.handleFetchMissions();
    };

    //handletypeOfROMSelectChange = async (e, v, vname) => {
    //    e.persist();

    //    if (v !== undefined & v !== null) {
    //        await this.setState({ [vname]: v.TypeId });
    //    } else {
    //        await this.setState({ [vname]: -1 });
    //    }

    //    //console.log(vname + ": " + e.target.value);
    //    console.log(this.state);
    //}

    handleChange = async (e) => {
        e.persist();
        await this.setState({ [e.target.name]: e.target.value });
    };

    handleChangeDate = (name, value) => {
        //this.setState({
        //    [name]: new Date(value),
        //    [name + "Changed"]: true
        //});
        this.setState({
            [name]: new Date(moment(value).format('YYYY-MM-DD')),
            [name + "Changed"]: true
        });
        //this.setState({ [name]: new Date(moment(value).format('YYYY-MM-DD')) });
    };

    //handleSelectChange = event => {
    //    this.setState({ [event.target.name]: event.target.value });
    //};

    handleSelectChange = async (e, v, vname) => {
        e.persist();

        if (v !== undefined & v !== null) {
            await this.setState({ [vname]: v.TypeId });
        } else {
            await this.setState({ [vname]: -1 });
        }

        //console.log(vname + ": " + e.target.value);
        console.log(this.state);
    }

    handleSelectQuestionChange = async (e, v) => {
        e.persist();

        if (v !== undefined & v !== null) {
            await this.setState({ ["reportQuestion"]: v.TypeId });
            await this.setState({ ["reportQuestionTitle"]: v.TypeName });
        } else {
            await this.setState({ ["reportQuestion"]: -1 });
            await this.setState({ ["reportQuestionTitle"]: -1 });
        }

        //console.log(vname + ": " + e.target.value);
        console.log(this.state);
    }

    handleROMTypeSelectChange = async (e, v) => {
        e.persist();

        if (v !== undefined & v !== null) {
            await this.setState({ ["typeOfROM"]: v.TypeId });
        } else {
            await this.setState({ ["typeOfROM"]: -1 });
        }

        //console.log(vname + ": " + e.target.value);
        console.log(this.state);

        if (this.state.typeOfROM === 1) {
            this.setState({
                questions: this.state.questionsOngoingMQ
            });
        } else if (this.state.typeOfROM === 2) {
            this.setState({
                questions: this.state.questionsExpostMQ
            });
        } else if (this.state.typeOfROM === 3) {
            this.setState({
                questions: this.state.questionsSupplyOngoing
            });
        } else if (this.state.typeOfROM === 4) {
            this.setState({
                questions: this.state.questionsSupplyExpost
            });
        } else if (this.state.typeOfROM === 5) {
            this.setState({
                questions: this.state.questionsWorksOngoing
            });
        } else if (this.state.typeOfROM === 6) {
            this.setState({
                questions: this.state.questionsWorksExpost
            });
        }

        this.handleFetchMissions();

        await this.setState({
            selectedMissions: [],
            rowsSelectedMission: [],
        });
    }

    handleSelectChangeWithValue = async (e, v, vname) => {
        e.persist();

        if (v !== undefined & v !== null) {
            await this.setState({ [vname]: v.TypeId });
        } else {
            await this.setState({ [vname]: -1 });
        }

        //console.log(vname + ": " + e.target.value);
        console.log(this.state);
    }

    handleFetchMissions = async (e) => {

        await this.setState({ isFetching: true });

        console.log(this.state);

        let pageData = {
            operation: "FetchMission",
            TypeOfROM: this.state.typeOfROM
        };

        //await fetch(global.variables.API_PROJECTDETAILS_GETLISTOFMISSIONSBYROMTYPE, {
        await fetch(global.variables.API_PROJECTDETAILS_GETLISTOFSAVEDANDFINISHEDMISSIONSBYROMTYPE, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(pageData)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                this.setState({ missionList: result.missions });
            });

        await this.setState({ isFetching: false });
    };

    handleFetchMissionsFilterByDate = async (e) => {

        await this.setState({ isFetching: true });

        console.log(this.state);

        let pageData = {
            operation: "FetchMission",
            TypeOfROM: this.state.typeOfROM,
            dateStart: this.state.missionDateSearchStart,
            dateEnd: this.state.missionDateSearchEnd,
            sector: this.state.sector,
        };

        await fetch(global.variables.API_PROJECTDETAILS_GETLISTOFSAVEDANDFINISHEDMISSIONSBYROMTYPEFILTERBYDATE, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(pageData)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                this.setState({ missionList: result.missions });
            });

        await this.selectAllMissionsOnMuiTable();

        await this.setState({ isFetching: false });
    };

    handleGenerateReport = async (e) => {

        await this.setState({ isFetching: true });

        console.log(this.state);

        //let pageData = {
        //    operation: "FetchReport",
        //    TypeOfROM: this.state.typeOfROM
        //};

        await fetch(global.variables.API_REPORTGENERATOR_GENERATETHEMATICREPORT, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(this.state)
        })
            .then(response => response.json())
            .then(result => {
                console.log("Thematic Report");
                console.log(result);

                if (result.resultstate === 0) {
                    this.setState({
                        thematicReport: result.thematicreport
                    });
                }
            });

        await this.setState({ isFetching: false });
    };

    handleGetConclusions = async (e) => {

        await this.setState({ isFetching: true });

        if (this.state.typeOfROM === 1) {
            // Ongoing
            await this.setState({ ["reportQuestion"]: "OmrConclusions" });
            await this.setState({ ["reportQuestionTitle"]: "Ongoing MR - Conclusions" });
        } else if (this.state.typeOfROM === 2) {
            // Expost
            await this.setState({ ["reportQuestion"]: "EmrConclusions" });
            await this.setState({ ["reportQuestionTitle"]: "Ex-post MR - Conclusions" });
        }

        console.log(this.state);

        //let pageData = {
        //    operation: "FetchReport",
        //    TypeOfROM: this.state.typeOfROM
        //};

        await fetch(global.variables.API_REPORTGENERATOR_GENERATETHEMATICREPORT, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(this.state)
        })
            .then(response => response.json())
            .then(result => {
                console.log("Thematic Report");
                console.log(result);

                if (result.resultstate === 0) {
                    this.setState({
                        thematicReport: result.thematicreport
                    });
                }
            });

        await this.setState({ isFetching: false });
    };

    handleGetRecommendations = async (e) => {

        await this.setState({ isFetching: true });

        if (this.state.typeOfROM === 1) {
            // Ongoing
            await this.setState({ ["reportQuestion"]: "OmrRecommendations" });
            await this.setState({ ["reportQuestionTitle"]: "Ongoing MR - Recommendations" });
        } else if (this.state.typeOfROM === 2) {
            // Expost
            await this.setState({ ["reportQuestion"]: "EmrLessonsLearnt" });
            await this.setState({ ["reportQuestionTitle"]: "Ex-post MR - Lessons Learnt" });
        }

        console.log(this.state);

        //let pageData = {
        //    operation: "FetchReport",
        //    TypeOfROM: this.state.typeOfROM
        //};

        await fetch(global.variables.API_REPORTGENERATOR_GENERATETHEMATICREPORT, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(this.state)
        })
            .then(response => response.json())
            .then(result => {
                console.log("Thematic Report");
                console.log(result);

                if (result.resultstate === 0) {
                    this.setState({
                        thematicReport: result.thematicreport
                    });
                }
            });

        await this.setState({ isFetching: false });
    };

    handleExportReportWord = async (e) => {

        await this.setState({ isFetching: true });

        await this.setState({ returnFileType: 0 }); //0: Word, 1: PDF

        console.log(this.state);

        //let pageData = {
        //    operation: "FetchReport",
        //    TypeOfROM: this.state.typeOfROM
        //};

        await fetch(global.variables.API_REPORTGENERATOR_EXPORTTHEMATICREPORT, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(this.state)
        })
            .then(response => response.json())
            .then(result => {
                console.log("Thematic Report");
                console.log(result);

                var a = document.createElement('a');
                a.href = '/api/FileUploadDownload/DownloadThematicReportTemplate/' + btoa(localStorage.getItem("authtoken")) + '/' + result.downloadfilename;
                a.download = result.filename;
                console.log(a);
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            });

        await this.setState({ isFetching: false });
    };

    handleExportReportPDF = async (e) => {

        await this.setState({ isFetching: true });

        await this.setState({ returnFileType: 1 }); //0: Word, 1: PDF

        console.log(this.state);

        //let pageData = {
        //    operation: "FetchReport",
        //    TypeOfROM: this.state.typeOfROM
        //};

        await fetch(global.variables.API_REPORTGENERATOR_EXPORTTHEMATICREPORT, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(this.state)
        })
            .then(response => response.json())
            .then(result => {
                console.log("Thematic Report");
                console.log(result);

                var a = document.createElement('a');
                a.href = '/api/FileUploadDownload/DownloadThematicReportTemplate/' + btoa(localStorage.getItem("authtoken")) + '/' + result.downloadfilename;
                a.download = result.filename;
                console.log(a);
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            });

        await this.setState({ isFetching: false });
    };

    returnArrayElement = (array, element) => {
        for (var i = 0; i < array.length; i++) {
            if (array[i].TypeId == element) {
                return array[i];
            }
        }
        return ({ TypeId: "", TypeName: "" });
    };

    //onRowClick = (rowData: string[], rowMeta: { dataIndex: number, rowIndex: number }) => {
    //    console.log("----RowClick");
    //    console.log("rowData: ", rowData);
    //    console.log("rowMeta: ", rowMeta);
    //}

    onRowsSelectQuestionNumber = (allRowsSelected) => {
        //console.log("---RowSelect")
        //console.log("Row Selected: ", curRowSelected);
        //console.log("All Selected: ", allRowsSelected);

        var selectedRows = [];

        allRowsSelected.map((row) => {

            //console.log(row + " :: ");
            //console.log(this.state.questionsOngoingMQ[row]);

            if (this.state.typeOfROM === 1) {
                selectedRows.push(this.state.questionsOngoingMQ[row]);
            } else {
                selectedRows.push(this.state.questionsExpostMQ[row]);
            }
        });

        //console.log(selectedRows);

        this.setState({ selectedQuestions: selectedRows });

        console.log(this.state);
    }

    onRowsSelectMission = async (allRowsSelected) => {
        var selectedRows = [];

        allRowsSelected.map((row) => {
            selectedRows.push(this.state.missionList[row]);
        });

        await this.setState({ selectedMissions: selectedRows });

        //this.selectAllMissionsOnMuiTable();

        console.log(this.state);
    }

    selectAllMissionsOnMuiTable = () => {
        console.log("Selecting All Missions");

        var selectedMissionsOnMuiTable = [];
        var selectedMissionsList = [];

        for (var i = 0; i < this.state.missionList.length; i++) {
            selectedMissionsOnMuiTable.push(i);
            selectedMissionsList.push(this.state.missionList[i]);
        }

        if (selectedMissionsList.length > 0) {
            this.setState({
                selectedMissions: selectedMissionsList,
                rowsSelectedMission: selectedMissionsOnMuiTable
            });
        }
    };

    render() {

        const {
            missionList,
            typeOfROM,
            typeOfROMOptions,
            isFetching,
            questions,
            reportQuestion,
            thematicReport,
            missionDateSearchStart,
            missionDateSearchEnd,
            sector,
        } = this.state;

        return (
            <div style={{ maxWidth: '100%' }}>
                <Grid container spacing={3} >
                    <Grid>
                        <ToastContainer />
                    </Grid>

                    <Grid item xs={6} height="100%">
                        <Card>
                            <CardHeader title="ROM Mission Type" className='romis-card-header' />
                            <CardContent>
                                <Autocomplete
                                    options={typeOfROMOptions}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleROMTypeSelectChange(e, v)}
                                    renderInput={params => (
                                        <TextField {...params} label="Type of ROM" margin="normal" fullWidth />
                                    )}
                                    value={this.returnArrayElement(typeOfROMOptions, typeOfROM)}
                                />
                            </CardContent>
                        </Card>
                    </Grid>

                    <Grid item xs={6} height="100%">
                        <Card>
                            <CardHeader title="Sector" className='romis-card-header' />
                            <CardContent>
                                <Autocomplete
                                    options={sectorOptions}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChange(e, v, "sector")}
                                    value={this.returnArrayElement(sectorOptions, sector)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            label="Sector"
                                            placeholder="Sector"
                                            fullWidth
                                            margin="normal"
                                        />
                                    )}
                                />
                            </CardContent>
                        </Card>
                    </Grid>


                    <Grid item xs={12} height="100%">
                        <Card>
                            <CardHeader title="Mission Dates" className="romis-card-header" />
                            <CardContent>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <Grid container spacing={3} >
                                        <Grid item xs={5} height="100%">
                                            <KeyboardDatePicker
                                                margin="normal"
                                                variant="inline"
                                                label="Mission Date Search Start :"
                                                format="dd/MM/yyyy"
                                                fullWidth
                                                onChange={value => {
                                                    this.handleChangeDate("missionDateSearchStart", value);
                                                }}
                                                value={missionDateSearchStart}
                                                name="missionDateSearchStart"
                                                InputLabelProps={{
                                                    shrink: true
                                                }}
                                                autoOk
                                            />
                                        </Grid>
                                        <Grid item xs={5} height="100%">
                                            <KeyboardDatePicker
                                                margin="normal"
                                                variant="inline"
                                                label="Mission Date Search End :"
                                                format="dd/MM/yyyy"
                                                fullWidth
                                                onChange={value => {
                                                    this.handleChangeDate("missionDateSearchEnd", value);
                                                }}
                                                value={missionDateSearchEnd}
                                                name="missionDateSearchEnd"
                                                InputLabelProps={{
                                                    shrink: true
                                                }}
                                                autoOk
                                            />
                                        </Grid>
                                        <Grid item xs={2} height="100%" style={{ textAlign: "center" }}>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                onClick={this.handleFetchMissionsFilterByDate.bind(this)}
                                                disabled={isFetching ? true : false}
                                            >
                                                Filter by Date & Sector
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </MuiPickersUtilsProvider>
                            </CardContent>
                        </Card>
                    </Grid>




                    <Grid item xs={12} height="100%">
                        <Card>
                            <CardHeader title="Select Mission" className='romis-card-header' />
                            <CardContent>
                                <MUIDataTable
                                    title={"Missions"}
                                    data={this.state.missionList}
                                    columns={[
                                        {
                                            name: "idMissionDetails",
                                            options: {
                                                display: false
                                            }
                                        },
                                        {
                                            name: "ProjectNumber",
                                            label: "Project Number",
                                            options: {
                                                filter: true,
                                                sort: true
                                            }
                                        },
                                        {
                                            name: "ProjectTitle",
                                            label: "Project Name",
                                            options: {
                                                filter: true,
                                                sort: true
                                            }
                                        },
                                        //{
                                        //    name: "TypeOfProject",
                                        //    label: "Type of Project",
                                        //    options: {
                                        //        filter: true,
                                        //        sort: true
                                        //    }
                                        //},
                                        {
                                            name: "MissionNumber",
                                            label: "Mission Number",
                                            options: {
                                                filter: true,
                                                sort: true
                                            }
                                        },

                                    ]}
                                    options={{
                                        filterType: "checkbox",
                                        //onRowClick: this.onRowClick,
                                        rowsSelected: this.state.rowsSelectedMission,
                                        onRowsSelect: (rowsSelected, allRows) => {
                                            const selected = allRows.map(item => item.index);

                                            //console.log("Selected: " + selected);

                                            this.setState({
                                                rowsSelectedMission: selected,
                                            });

                                            this.onRowsSelectMission(selected);
                                        },
                                        //onRowsSelect: this.onRowsSelect,
                                        pageSize: 20
                                    }}
                                />
                            </CardContent>
                        </Card>
                    </Grid>

                    <Grid item xs={12} height="100%">

                        <Card>
                            <CardHeader title="Select Question Number" className='romis-card-header' />
                            <CardContent>
                                <Grid container xs={12}>
                                    <Grid item xs={12}>
                                        <Autocomplete
                                            options={questions}
                                            getOptionLabel={option => option.TypeName}
                                            autoComplete
                                            includeInputInList
                                            onChange={(e, v) => this.handleSelectQuestionChange(e, v)}
                                            renderInput={params => (
                                                <TextField {...params} label="Select Question" margin="normal" fullWidth />
                                            )}
                                            value={this.returnArrayElement(questions, reportQuestion)}
                                        />
                                        {
                                            //<MUIDataTable
                                            //    title={"Questions"}
                                            //    data={typeOfROM === 1 ? this.state.questionsOngoingMQ : this.state.questionsExpostMQ}
                                            //    columns={[
                                            //        {
                                            //            name: "questionname",
                                            //            options: {
                                            //                display: false
                                            //            }
                                            //        },
                                            //        {
                                            //            name: "questionlabel",
                                            //            label: "Question Label",
                                            //            options: {
                                            //                filter: true,
                                            //                sort: true
                                            //            }
                                            //        }]}
                                            //    options={{
                                            //        filterType: "checkbox",
                                            //        //onRowClick: this.onRowClick,
                                            //        rowsSelected: this.state.rowsSelectedQuestionNumber,
                                            //        onRowsSelect: (rowsSelected, allRows) => {
                                            //            const selected = allRows.map(item => item.index);

                                            //            //console.log("Selected: " + selected);

                                            //            this.setState({
                                            //                rowsSelectedQuestionNumber: selected,
                                            //            });

                                            //            this.onRowsSelectQuestionNumber(selected);
                                            //        },
                                            //        //onRowsSelect: this.onRowsSelect
                                            //    }}
                                            ///>
                                        }
                                    </Grid>

                                    <Grid item xs={12} style={{ textAlign: "center" }}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={this.handleGenerateReport.bind(this)}
                                            disabled={isFetching ? true : false}
                                        >
                                            Get Report
                                        </Button>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </Grid>

                    {
                        //<Grid item xs={12} style={{ textAlign: "center" }}>
                        //    <Button
                        //        variant="contained"
                        //        color="primary"
                        //        onClick={this.handleGenerateReport.bind(this)}
                        //        disabled={isFetching ? true : false}
                        //    >
                        //        Get Report
                        //    </Button>
                        //</Grid>
                    }


                    <Grid item xs={12} height="100%">

                        <Card>
                            <CardHeader title="Conclusions and Recommendations" className='romis-card-header' />
                            <CardContent>
                                <Grid container xs={12}>
                                    <Grid item xs={6} style={{ textAlign: "center" }}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={this.handleGetConclusions.bind(this)}
                                            disabled={isFetching ? true : false}
                                        >
                                            Get Conclusions
                                        </Button>
                                    </Grid>

                                    <Grid item xs={6} style={{ textAlign: "center" }}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={this.handleGetRecommendations.bind(this)}
                                            disabled={isFetching ? true : false}
                                        >
                                            Get Recommendations
                                        </Button>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </Grid>

                    <Grid>
                        <ToastContainer />
                    </Grid>

                    <Grid item xs={12} height="100%"
                        style={{ display: thematicReport.length > 0 ? "block" : "none" }}>
                        <Card>
                            <CardHeader title="Answers" className='romis-card-header' />
                            <CardContent>

                                <Grid item xs={12}>
                                    {thematicReport.map((element, index) =>
                                        <Grid item xs={12} sm={12} md={12} key={"gridArea" + index} >
                                            <Typography variant="subtitle2">
                                                <strong>
                                                    {element.TemplateAnswer === null ? "Mission" : element.MissionNumber + " " + element.ProjectTitle}
                                                </strong>
                                            </Typography>
                                            <TextareaAutosize
                                                style={{ width: "100%" }}
                                                name={"txtArea" + index}
                                                rows={6}
                                                value={element.TemplateAnswer === null ? "" : element.TemplateAnswer}

                                            />
                                        </Grid>
                                    )}
                                </Grid>

                                <Grid item xs={12} style={{ textAlign: "center", marginTop: "25px" }}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={this.handleExportReportWord.bind(this)}
                                        disabled={isFetching ? true : false}
                                        style={{ marginRight: "20px" }}
                                    >
                                        Export to Word
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={this.handleExportReportPDF.bind(this)}
                                        disabled={isFetching ? true : false}
                                        style={{ marginLeft: "20px" }}
                                    >
                                        Export to PDF
                                    </Button>
                                </Grid>

                            </CardContent>
                        </Card>
                    </Grid>

                </Grid>
            </div >
        );
    }
}




// WEBPACK FOOTER //
// ./src/pages/ThematicReport.js